import React, { useEffect, useMemo } from "react";
import { Position, useReactFlow } from "@xyflow/react";
import classNames from "classnames";
import { RiAddCircleLine } from "react-icons/ri";
import { RiCloseLine } from "@remixicon/react";
import Styles from "./Nodes.module.scss";
import BaseHandle from "../BaseHandle";
import { useWorkflowSidebar } from "../../providers/WorkflowSidebarProvider";
import Icon from "../../../theme/icon/Icon";
import Button from "../../../theme/button/Button";
import { SidebarContent, useWorkflowModal } from "../../providers/WorkflowModalProvider";

export default function NewActionNode() {
    const { resetTemporaryState } = useWorkflowSidebar();
    const { getNodes } = useReactFlow();
    const { setIsSidebarOpen, setSidebarContent } = useWorkflowModal();

    const nodes = useMemo(() => getNodes(), []);

    // TODO: Is there a better way to check if the flow is empty?
    const isEmptyFlow = useMemo(() => nodes.length <= 3, [nodes]);

    const handleDeleteNode = () => {
        resetTemporaryState();
    };

    useEffect(() => {
        if (isEmptyFlow) {
            setIsSidebarOpen(true);
            setSidebarContent(SidebarContent.ACTIONS);
        }
    }, [isEmptyFlow]);

    return (
        <>
            <BaseHandle type="target" position={Position.Left} id="b" />
            <div className={classNames(Styles["node-container"], Styles["new-action-node-container"])}>
                <button type="button" className={classNames(Styles["new-action-node"], Styles["draggable-node-wrapper"])}>
                    <Icon
                        icon={<RiAddCircleLine />}
                        variant="primary"
                        className={Styles["new-action-node-icon"]}
                        size="small"
                    />
                    <div className={Styles["vertical-line"]} />
                    <div>
                        <span className={classNames(Styles["overflow-ellipsis"], Styles["node-title"])}>Action</span>
                        <p className={classNames(
                            Styles["overflow-ellipsis"],
                            Styles["node-description"],
                            Styles["new-action-node-description"],
                        )}
                        >
                            Choose new action to add...
                        </p>
                    </div>
                    {
                        !isEmptyFlow && (
                            <div className={Styles["dropdown-container"]}>
                                <Button
                                    variant="none"
                                    size="small"
                                    onClick={handleDeleteNode}
                                    prefixIcon={(
                                        <Icon
                                            variant="default"
                                            icon={<RiCloseLine />}
                                            size="small"
                                            className={Styles["options-icon"]}
                                            isRounded
                                        />
                                    )}
                                />
                            </div>
                        )
                    }
                </button>
            </div>

        </>
    );
}
